/**
 * utils/index.js — Barrel export for all utilities
 */

export { normalize, normalizeWithMap, escapeRegExp, escapeHtml, parseQuery } from "./normalize";
export { highlightSimple, unhighlightSimple, highlightAccent, unhighlightAccent, highlightJQ, unhighlightJQ } from "./highlight";
export { ensureLoaderStyles, createLoader } from "./loader";
export { getTopOffset, smoothScrollTo } from "./scroll";
export { debounce } from "./debounce";
